import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

export const getAdminStatistics = async (fromDate, toDate) => {
  const token =
        localStorage.getItem("authToken");// apne project ki key check karo

  const response = await axios.get(
    `${BASE_URL}/food/api/orders/admin/statistics`,
    {
      params: {
        fromDate,
        toDate,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};